"use client";

import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import BaseLayout from "./BaseLayout";
import LcaSideBar from "../../components/Header/LocalCummunityAds/LcaDuplicate/LcaSideBar";
import {
  fetchItems,
  fetchSubCategories,
  fetchCategories,
  fetchSubCategoriesById,
} from "../../components/Header/Data";

import { myOffers } from "../../components/Header/Data2";
import {
  setActiveTab,
  setSelectedSubCategory,
  setGottonData,
  setMyOffers,
} from "../../redux/slices/LcaSlice";
import { clearLcaAndBwv } from "../../redux/slices/LcaAndBwvSlice";
import axiosClient from "../../axios-client";

const LcaSidebarLayout = ({ children, islogin }) => {
  const [scrollPopupVisible, setScrollPopupVisible] = useState(false);
  const [productSubCat, setProductSubCat] = useState([]);
  const [items, setItems] = useState([]);
  const fetchDataCalled = useRef(false);
  const gottonFetched = useRef(false);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const code = new URLSearchParams(location.search).get("code");

  useEffect(() => {
    if (code) {
      localStorage.setItem("code", code);
      navigate("/dashboardpage/settings");
    }
  }, [code]);

  const fetchData = async () => {
    try {
      const response = await axiosClient.get(`subcategory/getSubCategorys/1`);
      if (response.data.statusCode === 200) {
        const subCategories = response.data.subCategoryList;
        setProductSubCat(subCategories);
        const itemsData = await fetchItems();
        const filterItems = itemsData.filter((item) =>
          subCategories.some((subCat) => item.subCatId === subCat.id)
        );
        setItems(filterItems);
      } else {
        throw new Error(response.data.msg);
      }
    } catch (error) {
      throw new Error("Error fetching SubCategories");
    }
  };
  useEffect(() => {
    if (!fetchDataCalled.current) {
      fetchData();
      fetchDataCalled.current = true;
    }
    if (user && islogin && !gottonFetched.current) {
      fetchGotton();
      gottonFetched.current = true;
    }
    dispatch(setActiveTab("Customers"));
    dispatch(setSelectedSubCategory(null));
    return () => {
      dispatch(clearLcaAndBwv());
    };
  }, []);

  const fetchGotton = async () => {
    try {
      const response = await axiosClient.put(
        `message/TotalMsgMonthGetCustomer/${Number.parseInt(user.UserID)}`
      );
      const data = response.data.Data;
      const currentMonth = new Date().getMonth() + 1;
      const currentYear = new Date().getFullYear();
      const currentMonthStr = currentMonth.toString().padStart(2, "0");
      const filteredData = data.find((item) => {
        const itemMonth = item.MONTH.split("-")[1];
        const itemYear = item.MONTH.split("-")[0];
        return (
          itemMonth === currentMonthStr && itemYear === currentYear.toString()
        );
      });
      dispatch(setGottonData(filteredData));
    } catch (error) {
      console.error("Error fetching Gotton data:", error);
    }
  };

  useEffect(() => {
    if (islogin) {
      fetchMyOffers();
    }
  }, []);

  const fetchMyOffers = async () => {
    const type = {
      Type: "provider",
    };
    const id = user?.UserID;
    const response = await myOffers(id, type);
    dispatch(setMyOffers(response));
  };

  const sidebarProps = {
    items,
    productSubCat,
    setScrollPopupVisible,
  };
  console.log(productSubCat, "productSubCat");
  const enhancedChildren = React.Children.map(children, (child) =>
    React.isValidElement(child)
      ? React.cloneElement(child, {
          items,
          productSubCat,
          scrollPopupVisible,
          setScrollPopupVisible,
        })
      : child
  );

  return (
    <BaseLayout
      SidebarComponent={LcaSideBar}
      sidebarProps={sidebarProps}
      islogin={islogin}
    >
      {enhancedChildren}
    </BaseLayout>
  );
};

export default LcaSidebarLayout;
